module.exports = __webpack_public_path__ + "fb66dedf.svg";